module.exports = __webpack_public_path__ + "static/media/image1.52f532e0.png";